import { inject, Injectable } from "@angular/core";
import { DateTime } from "luxon";
import {
  Meter,
  MeterFeature,
  MeterType,
} from "src/app/core/models/meter.model";
// import { AlertDefinition } from "src/app/core/models/old-alert-definition.model";
// import {
//   Alert,
//   AlertDevice,
//   Anomaly,
//   AnomalyType,
//   DeviceType,
// } from "src/app/core/models/old-alert.model";
import { Place } from "src/app/core/models/place.model";
import { PlaceStats } from "src/app/core/models/placestats.model";
import { ShowerHead } from "src/app/core/models/shower-head.model";
import { Threshold } from "src/app/core/models/threshold.model";
import { UtilsService } from "src/app/shared/services/utils.service";

const LOG_TAG = "[TOUR]";

@Injectable({
  providedIn: "root",
})
export class TourService {
  private static _TOUR_DELAY = 1000;
  private _utilsService: UtilsService = inject(UtilsService);

  public get fakeMeter() {
    return this._fakeMeter;
  }
  public get fakeSh() {
    return this._fakeSh;
  }
  public get fakeSh2() {
    return this._fakeSh2;
  }
  public get meterDataMonth() {
    return this._meterDataMonth;
  }
  public get shDataMonth() {
    return this._shDataMonth;
  }
  public get totalMeterVolMonth() {
    return this._totalMeterVolMonth;
  }
  public get totalShVolMonth() {
    return this._totalShVolMonth;
  }
  public get totalNbShowerMonth() {
    return this._totalNbShowerMonth;
  }
  public get meterDataLast30d() {
    return this._meterDataLast30d.slice().reverse();
  }
  public get shDataLast30d() {
    return this._shDataLast30d;
  }
  public get fakePlaceStats() {
    return this._fakePlaceStats;
  }
  public get fakePlaces() {
    return this._fakePlaces;
  }
  private _dataInitalized = false;

  private _fakeMeter: Meter;
  private _fakeSh: ShowerHead;
  private _fakeSh2: ShowerHead;
  private _meterDataMonth: [DateTime, number][];
  private _shDataMonth: [DateTime, number, number][];
  private _totalMeterVolMonth: number;
  private _totalShVolMonth: number;
  private _totalNbShowerMonth: number;
  private _meterDataLast30d: [DateTime, number][];
  private _shDataLast30d: [DateTime, number][];

  private _fakePlaceStats: PlaceStats[];
  private _fakePlaces: Place[];

  public initData() {
    if (this._dataInitalized) return;
    this._computeDevicesData();
    this._dataInitalized = true;
  }

  private _computeDevicesData() {
    this._fakeMeter = new Meter(
      "012345678",
      DateTime.local().minus({ month: 3 }),
      DateTime.local().minus({ minutes: 3 }),
      "Meter 1",
      "JA012345",
      DateTime.local(),
      null,
      null,
      [
        MeterFeature.hourly_signal,
        MeterFeature.raw_signal,
        MeterFeature.threshold_alerts,
        MeterFeature.period_alerts,
        MeterFeature.smart_alerts,
        MeterFeature.labelling,
      ],
      MeterType.drac_flowmeter,
      null,
      75,
      null,
      null,
      null
    );

    this._fakeSh = new ShowerHead(
      "1",
      DateTime.local().minus({ months: 3 }),
      DateTime.local().minus({ hours: 6 }),
      Threshold.DEFAULT_THRESHOLDS,
      null,
      "showerhead 1",
      "00_00_0000",
      "aloe",
      "LoRa",
      "123",
      "456",
      1,
      null
    );

    this._fakeSh2 = new ShowerHead(
      "2",
      DateTime.local().minus({ months: 12 }),
      DateTime.local().minus({ months: 6 }),
      Threshold.DEFAULT_THRESHOLDS,
      null,
      "showerhead 2",
      "00_00_0001",
      "Cereus",
      "BLE",
      "123",
      "456",
      1,
      null
    );
    this._meterDataMonth = [];
    this._meterDataLast30d = [];
    this._shDataMonth = [];
    this._shDataLast30d = [];

    let beginOfMonth = DateTime.local().set({
      day: 0,
      hour: 0,
      minute: 0,
      second: 0,
      millisecond: 0,
    });
    this._totalMeterVolMonth = 0;
    this._totalShVolMonth = 0;
    this._totalNbShowerMonth = 0;
    for (
      let date = DateTime.local().set({
        hour: 0,
        minute: 0,
        second: 0,
        millisecond: 0,
      });
      date >
      DateTime.local()
        .minus({ days: 30 })
        .set({ hour: 0, minute: 0, second: 0, millisecond: 0 });
      date = date.minus({ day: 1 })
    ) {
      let vol = Math.round(Math.random() * 80) + 40;
      let shVol = Math.round(Math.random() * 60) + 30;
      let nbSh = Math.round(Math.random() * 2) + 1;

      if (date >= beginOfMonth) {
        this._totalMeterVolMonth += vol;
        this._totalShVolMonth += shVol;
        this._totalNbShowerMonth += nbSh;
        this._meterDataMonth.push([date, vol]);
        this._meterDataLast30d.push([date, vol]);
        this._shDataMonth.push([date, shVol, nbSh]);
        this._shDataLast30d.push([date, shVol]);
      } else {
        this._meterDataLast30d.push([date, vol]);
        this._shDataLast30d.push([date, shVol]);
      }

      //graph.push(new MeterGraphElement(date.toJSDate(), 6.0, 0, vol));
    }
  }
}
